const RELOAD_KEY = 'app.stale-build-reload';

const RELOAD_DELAYS = [0, 2_000, 5_000];

const RELOAD_WINDOW = 60_000;

const CHUNK_ERROR = /dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

let reloading = false;

export const isChunkLoadError = (error) => CHUNK_ERROR.test(String(error?.message ?? error ?? ''));

const previousAttempts = () => {
	const { at = 0, count = 0 } = JSON.parse(sessionStorage.getItem(RELOAD_KEY) ?? '{}') ?? {};

	return Date.now() - at < RELOAD_WINDOW ? count : 0;
};

export const reloadForNewBuild = () => {
	if (reloading) {
		return true;
	}

	let attempt;

	try {
		attempt = previousAttempts();

		if (attempt >= RELOAD_DELAYS.length) {
			return false;
		}

		sessionStorage.setItem(RELOAD_KEY, JSON.stringify({ at: Date.now(), count: attempt + 1 }));
	} catch {
		return false;
	}

	reloading = true;
	setTimeout(() => window.location.reload(), RELOAD_DELAYS[attempt]);

	return true;
};
